var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_3890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.6885H7C6.76794 13.6885 6.54538 13.7807 6.38128 13.9448C6.21719 14.1089 6.125 14.3314 6.125 14.5635C6.125 14.7955 6.21719 15.0181 6.38128 15.1822C6.54538 15.3463 6.76794 15.4385 7 15.4385H21C21.2321 15.4385 21.4546 15.3463 21.6187 15.1822C21.7828 15.0181 21.875 14.7955 21.875 14.5635C21.875 14.3314 21.7828 14.1089 21.6187 13.9448C21.4546 13.7807 21.2321 13.6885 21 13.6885Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.375 8.43848H2.625C2.39294 8.43848 2.17038 8.53066 2.00628 8.69476C1.84219 8.85885 1.75 9.08141 1.75 9.31348C1.75 9.54554 1.84219 9.7681 2.00628 9.93219C2.17038 10.0963 2.39294 10.1885 2.625 10.1885H25.375C25.6071 10.1885 25.8296 10.0963 25.9937 9.93219C26.1578 9.7681 26.25 9.54554 26.25 9.31348C26.25 9.08141 26.1578 8.85885 25.9937 8.69476C25.8296 8.53066 25.6071 8.43848 25.375 8.43848Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 18.9385H11.375C11.1429 18.9385 10.9204 19.0307 10.7563 19.1948C10.5922 19.3589 10.5 19.5814 10.5 19.8135C10.5 20.0455 10.5922 20.2681 10.7563 20.4322C10.9204 20.5963 11.1429 20.6885 11.375 20.6885H16.625C16.8571 20.6885 17.0796 20.5963 17.2437 20.4322C17.4078 20.2681 17.5 20.0455 17.5 19.8135C17.5 19.5814 17.4078 19.3589 17.2437 19.1948C17.0796 19.0307 16.8571 18.9385 16.625 18.9385Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_3890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.563477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.6b806756785cdca3429a22cef4c08c4c.svg";
export { ForwardRef as ReactComponent };